<template>
  <div class="box">
    <img class="bg" src="@/assets/image/home/qiyeshiming/bg.webp" alt="" srcset="" />
    <div class="content">
      <div class="top">
        <div class="icon">
          <img src="@/assets/image/home/qiyeshiming/icon.webp" alt="" srcset="" />
        </div>
      </div>
      <div class="title">
        <div class="title_t">申请加入</div>
        <div class="title_time">个人信息</div>
      </div>
      <div class="main">
        <div class="item">
          <div class="item_t">联系电话</div>
          <div class="item_b">{{ user.phone }}</div>
        </div>
        <div class="solid"></div>
        <div class="item">
          <div class="item_t">我的姓名</div>
          <div class="item_b">{{ user.name }}</div>
        </div>
        <div class="solid"></div>
        <div class="item">
          <div class="item_t">身份证号码</div>
          <div class="item_b">{{ user.idNumber }}</div>
        </div>
      </div>
      <div class="btns">
        <el-button class="button" plain type="primary" @click="onback">上一步</el-button>
        <el-button class="button" type="primary" @click="onnext">确定申请</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "./mixins";
import userinfo from "@/mixins/userinfo";
export default {
  mixins: [mixins, userinfo],
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    onback() {
      this.setStep("jiaru1");
    },
    onnext() {
      this.putCompanyJoin();
    },
    async putCompanyJoin() {
      try {
        await this.$api.putCompanyJoin({
          uuid: this.chaxunData.uuid,
        });
        this.setStep("jiaru3");
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use './style.scss' as *;
</style>
